<!-- @Author Shyam @Date 05/03/2026 @Description: Lifecycle Pop-up Component -->
<div class="topdiv">
  <div class="row topRowMargins headerStyle" style="margin-top: 0">
    <div style="margin-left: 15px">
      <label class="textColour">Lifecycle </label>
    </div>
  </div>
  <div class="mt-4 ps-3 ps-md-0">
    <form novalidate [formGroup]="validations_form">
      <div class="row g-3">
        <!-- Lifecycle -->
        <div class="col-12 col-md-6 col-lg-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Lifecycle</mat-label>
            <input
              matInput
              placeholder="Lifecyclename"
              type="text"
              formControlName="lifecyclename"
              [(ngModel)]="lifecycleRequestDto.lifecyclename"
              required
            />
            <mat-error
              *ngFor="let validation of validation_messages.lifecyclename"
            >
              <span
                *ngIf="
                  validations_form
                    .get('lifecyclename')
                    .hasError(validation.type) &&
                  (validations_form.get('lifecyclename').dirty ||
                    validations_form.get('lifecyclename').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Description -->
        <div class="col-12 col-md-6 col-lg-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Description</mat-label>
            <input
              matInput
              type="text"
              placeholder="description"
              formControlName="description"
              [(ngModel)]="lifecycleRequestDto.description"
            />
          </mat-form-field>
        </div>

        <!-- Object -->
        <!-- <div class="col-12 col-md-6 col-lg-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Object</mat-label>
           
            <mat-select
              multiple
              formControlName="objectname"
              (selectionChange)="onObjectChange($event)"
            >
              <span *ngFor="let object of objectsData">
                <mat-option [value]="object.id">{{
                  object.table_name
                }}</mat-option>
              </span>
            </mat-select>
          </mat-form-field>
        </div> -->

        <div class="col-12 col-md-6 col-lg-4">
          <mat-checkbox
            class="example-margin"
            [(ngModel)]="checked"
            formControlName="defualtlifecycle"
            (change)="onDefaultFilterChange()"
            >Default Lifecycle
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>

  <div class="row mt-4">
    <div class="col-12 align-items-center">
      <div>
        <div>
          <mat-toolbar
            class="agGridtoperDiv card"
            style="
              background: rgb(228 227 230 / 41%);
              border-top: 1px solid #a9a9a9a8;
              border-right: 1px solid #a9a9a9a8;
              border-left: 1px solid #a9a9a9a8;
            "
          >
            <label i18n="@@spmsUserReg" class="textColour"
              >Lifecycle States</label
            >

            <span class="example-spacer"></span>
            <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Configure Pivot" (click) = "openPivotConfigurationPopup()">Configure Visuals
                        </button> -->

            <!-- <div class="insertPageNoDiv">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                <input
                  matInput
                  type="text"
                  (input)="onSearchChange($event.target.value)"
                />
              </mat-form-field>
            </div> -->

            <!-- <div class="selectRecordsDiv" style="width: 9.5%">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label i18n="@@spmsUserRegrecords" style="color: black"
                  >Records</mat-label
                >
                <mat-select
                  [(ngModel)]="pagesize"
                  (ngModelChange)="onPageSizeChanged()"
                >
                  <mat-option value="5" selected>5</mat-option>
                  <mat-option value="10">10</mat-option>
                  <mat-option value="100">100</mat-option>
                  <mat-option value="200">200</mat-option>
                  <mat-option value="300">300</mat-option>
                  <mat-option value="400">400</mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->
            <!-- <div
              class="card pagination paginationFirstButton paginationFirstlastButton"
            >
              <em
                class="fas fa-angle-double-left waves-effect waves-light"
                (click)="onBtFirst()"
              ></em>
            </div> -->
            <!-- <div class="card pagination paginationButtons btn-rounded">
              <ul>
                <li class="paginationliicon">
                  <em
                    class="fas fa-angle-left waves-effect waves-light"
                    (click)="onBtPrevious()"
                  ></em>
                </li>
                <li>{{ currentpage }}/{{ totalpages }}</li>
                <li class="paginationliicon" style="padding: 0">
                  <em
                    class="fas fa-angle-right waves-effect waves-light"
                    (click)="onBtNext()"
                  ></em>
                </li>
              </ul>
            </div> -->
            <!-- <div
              class="card pagination paginationLastButton paginationFirstlastButton"
            >
              <em
                class="fas fa-angle-double-right waves-effect waves-light"
                (click)="onBtLast()"
              ></em>
            </div> -->
          </mat-toolbar>
        </div>
        <ag-grid-angular
          class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
          [columnDefs]="columnDefs"
          [animateRows]="true"
          [defaultColDef]="defaultColDef"
          [suppressPaginationPanel]="true"
          [suppressRowClickSelection]="true"
          [rowHeight]="35"
          [headerHeight]="35"
          [enableBrowserTooltips]="true"
          [floatingFiltersHeight]="45"
          [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter"
          [enableRangeSelection]="true"
          [debug]="true"
          [rowClassRules]="rowClassRules"
          (paginationChanged)="onPaginationChanged()"
          [components]="components"
          (gridReady)="onGridReady($event)"
          [hidden]="!true"
          [rowData]="rowData"
          [rowDragManaged]="true"
          [rowDragEntireRow]="false"
          (rowDragEnd)="onRowDragEnd($event)"
          style="height: 30vh; margin-bottom: 3%"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
  <!-- ================= LIFECYCLE STATES SECTION ================= -->
  <div class="mt-5 px-0">
    <!-- Section Title -->
    <div class="row mb-3">
      <div class="col-12">
        <h5 class="fw-bold headerStyle">Lifecycle States</h5>
        <hr />
      </div>
    </div>
    <form novalidate [formGroup]="formValid">
      <!-- State Entry Row -->
      <div class="row g-3 align-items-start">
        <!-- State Name -->
        <div class="col-12 col-md-4 col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>State Name</mat-label>
            <input
              matInput
              placeholder="Enter State Name"
              formControlName="statename"
              [(ngModel)]="lifecycleStatesrequestDto.statename"
            />
          </mat-form-field>
        </div>

        <!-- Initial / Final -->
        <div class="col-12 col-md-4 col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>State Type</mat-label>
            <mat-select
              formControlName="statetype"
              [(ngModel)]="lifecycleStatesrequestDto.statetype"
            >
              <mat-option *ngFor="let type of stateTypes" [value]="type">{{
                type
              }}</mat-option>
            </mat-select>
            <mat-error>
              <span
                *ngIf="
                  formValid.get('statetype').hasError('required') &&
                  (formValid.get('statetype').dirty ||
                    formValid.get('statetype').touched)
                "
              >
                State Type is required.
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Workflow Cancel State</mat-label>
            <mat-select
              formControlName="workflowcancelstate"
              [(ngModel)]="lifecycleStatesrequestDto.workflowcancelstate"
              (selectionChange)="onWorkFlowCancelState($event)"
            >
              <span *ngFor="let cancelsates of workflowCancelOptions">
                <mat-option [value]="cancelsates">
                  {{ cancelsates }}
                </mat-option>
              </span>
            </mat-select>
            <mat-error>
              <span
                *ngIf="
                  formValid.get('workflowcancelstate').hasError('required') &&
                  (formValid.get('workflowcancelstate').dirty ||
                    formValid.get('workflowcancelstate').touched)
                "
              >
                Workflow Cancel State is required.
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Add State Button -->
        <div class="col-12 col-md-4 col-lg-2 d-flex align-items-md-center">
          <label
            (click)="addState()"
            style="
              margin-top: 6px;
              background: green;
              margin-bottom: auto;
              padding: 2px 5px 0px 5px;
              border-radius: 15px;
            "
            ><em
              class="fas fa-plus"
              style="color: antiquewhite; font-size: large"
              title="Add States"
            ></em
          ></label>
        </div>
      </div>
    </form>
  </div>

  <div class="row mt-4 justify-content-end g-2 px-3">
    <!-- <div class="col-12 col-sm-6 col-md-3"> -->
    <app-common-button
      [label]="buttonName"
      [title]="buttonName"
      [critical]="true"
      [buttonId]="1111"
      width="110px"
      (clicked)="onSubmit()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
    <!-- </div> -->

    <!-- <div class="col-12 col-sm-6 col-md-3"> -->
    <app-common-button
      label="Cancel"
      title="Cancel"
      [critical]="true"
      [buttonId]="1111"
      variant="cancel"
      width="110px"
      (clicked)="onCancel()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
    <!-- </div> -->
  </div>
</div>
